import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TablePagination,
  Box,
  IconButton,
  Theme,
  useMediaQuery,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import AddExhibitorPopup from "../components/ViewAddPopup";
import Pound from "../../../assets/svgs/pounds.svg";
import Euro from "../../../assets/svgs/euro.svg";
import { Exhibitor } from "../exhibitorType/Exhibitor";
import TableAvatar from "../../../ui/components/TableAvatar";

interface ExhibitorsTableProps {
  exhibitors: Exhibitor[];
  refetchExhibitors: () => void;
}

const ExhibitorsTable: React.FC<ExhibitorsTableProps> = ({exhibitors,refetchExhibitors}) => {

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  const [selectedExhibitor, setSelectedExhibitor] = useState<Exhibitor>();

const handleEditClick = (exhibitor: Exhibitor) => {
  setSelectedExhibitor(exhibitor);
  setOpen(true);
};

  const [selected, setSelected] = useState<number[]>([]);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const allExhibitorIds = exhibitors.map((exhibitor) => exhibitor.id);
      setSelected(allExhibitorIds);
    } else {
      setSelected([]);
    }
  };
  

  const handleCheckboxClick = (id: number) => {
    setSelected((prevSelected) => {
      const isSelected = prevSelected.includes(id);
      if (isSelected) {
        // Deselect if already selected
        return prevSelected.filter((i) => i !== id);
      } else {
        // Select if not already selected
        return [...prevSelected, id];
      }
    });
  };

  const isSelected = (id: number) => selected.includes(id);

  return (
    <Box>
      <Box>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            height: isMobile ? "calc(100vh - 285px)" : "calc(100vh - 240px)",
            "&::-webkit-scrollbar": {
              width: "10px",
              height: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#949494",
              borderRadius: "8px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "rgba(242, 242, 242, 1)",
            },
          }}
        >
          <Table
            stickyHeader
            sx={{
              "& .MuiTableRow-root": {
                height: "36px",
              },
              "& .MuiTableCell-root": {
                padding: "4px",
                height: "56px",
                alignItems: "center",
              },
            }}
          >
            {exhibitors.length< 1 ?
               <TableRow>
               <TableCell colSpan={8} align="center" style={{ height: "100%" }}>
                 <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                   No Exhibitor Found!!!
                 </Box>
               </TableCell>
             </TableRow> : 
                  <>
                  
            <TableHead style={{backgroundColor:"rgba(240, 243, 246, 1)"}}>
              <TableRow>
                <TableCell align="center" sx={{ minWidth: "70px",backgroundColor:"rgba(240, 243, 246, 1)",color:"rgba(62, 74, 92, 1)" }}>Action</TableCell>

                {/* <TableCell padding="checkbox" sx={{ minWidth: "50px" }}>
                  <Checkbox
                    sx={{ color: "#00000099" }}
                    indeterminate={false}
                    checked={exhibitors.length > 0 && selected.length === exhibitors.length}
                    onChange={handleSelectAllClick}
                  />
                </TableCell> */}
                <TableCell sx={{ minWidth: "170px",backgroundColor:"rgba(240, 243, 246, 1)",color:"rgba(62, 74, 92, 1)" }}>Exhibitor</TableCell>
                <TableCell sx={{ minWidth: "100px",backgroundColor:"rgba(240, 243, 246, 1)",color:"rgba(62, 74, 92, 1)"}}>Price Model</TableCell>
                <TableCell
                  align="right"
                  sx={{ textAlign: "right", minWidth: "75px" ,backgroundColor:"rgba(240, 243, 246, 1)",color:"rgba(62, 74, 92, 1)"}}
                >
                  Price
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ textAlign: "right", minWidth: "100px",backgroundColor:"rgba(240, 243, 246, 1)",color:"rgba(62, 74, 92, 1)" }}
                >
                  Discount
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ textAlign: "center", minWidth: "120px",backgroundColor:"rgba(240, 243, 246, 1)",color:"rgba(62, 74, 92, 1)" }}
                >
                  Exhibitor Type
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ textAlign: "left", minWidth: "100px" ,backgroundColor:"rgba(240, 243, 246, 1)",color:"rgba(62, 74, 92, 1)"}}
                >
                  Currency
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {exhibitors.map((exhibitor) => {
                const isItemSelected = isSelected(exhibitor.id);
                const formatter = new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: exhibitor.currency || 'GBP',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                });
                return (
                  <TableRow
                    key={exhibitor.id}
                    hover
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Light grey on hover
                      },
                    }}
                  >
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        sx={{ color: "#00000099" }}
                        checked={isItemSelected}
                        onChange={() => handleCheckboxClick(exhibitor.id)}
                      />
                    </TableCell> */}
                  <TableCell align="center" sx={{ textAlign: "center" }}>
                    <IconButton onClick={() => handleEditClick(exhibitor)}>
                        <Edit style={{ color: "black", fontSize: "18px" }} />
                      </IconButton>
                    </TableCell>

                    <TableCell>
                       <TableAvatar name={exhibitor.name} />
                    </TableCell>

                    <TableCell>{exhibitor.price_model}</TableCell>
                    <TableCell align="right" sx={{ textAlign: "right" }}>
                    {exhibitor?.price_model=="matrix" ? exhibitor?.price?.ranges[0]?.under_2hrs +"-"+ exhibitor?.price?.ranges[3]?.over_2hrs : exhibitor?.price?.amount}
                    </TableCell>
                    {exhibitor.discount ?
                    <TableCell align="right" sx={{ textAlign: "right" }}>
                    {exhibitor.discount}%
                    </TableCell>
                    :
                    <TableCell align="right" sx={{ textAlign: "right" }}>
                    </TableCell>
                    }
                    <TableCell align="center" sx={{ textAlign: "center" }}>
                      {exhibitor.type}
                    </TableCell>
                    <TableCell align="left" sx={{ textAlign: "left" }}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="start"
                      >
                         {exhibitor.currency ? (
      (() => {
        const raw = formatter.format(0);
        const symbol = raw.replace(/[\d.,\s]/g, '');
        return symbol && symbol !== exhibitor.currency
          ? `${symbol} ${exhibitor.currency}`
          : exhibitor.currency;
      })()
    ) : ""}
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
              
            </TableBody>
            </>
}
          </Table>
        </TableContainer>
      </Box>
      <AddExhibitorPopup
        open={open}
        handleClose={handleClose}
        selectedExhibitor={selectedExhibitor}
        refetchExhibitors={refetchExhibitors}
      />
    </Box>
  );
};

export default ExhibitorsTable;
